import * as types from './mutation-types'
import _ from 'lodash'

export const mutations = {
  [types.ORDER_CREATE_LOADING](state) {
    state.order.loading = true
    state.order.data = null
    state.order.error = false
  },
  [types.ORDER_CREATE_ERROR](state, error) {
    state.order.loading = false
    state.order.data = null
    state.order.error = error
  },
  [types.ORDER_CREATE_COMPLETE](state, payload) {
    state.order.loading = false
    state.order.data = payload
    state.order.error = false
  },
  [types.SET_STRIPE_CLIENT_SECRET_LOADING](state) {
    state.stripe.loading = true
    state.stripe.data = null
    state.stripe.error = false
  },
  [types.SET_STRIPE_CLIENT_SECRET_ERROR](state, error) {
    state.stripe.loading = false
    state.stripe.data = null
    state.stripe.error = error
  },
  [types.SET_STRIPE_CLIENT_SECRET_COMPLETE](state, payload) {
    state.stripe.loading = false
    state.stripe.data = payload
    state.stripe.error = false
    localStorage.setItem("stripe_client_secret", payload.client_secret)
  },
  [types.CLEAN_STRIPE_CLIENT_SECRET](state) {
    state.stripe.loading = true
    state.stripe.data = null
    state.stripe.error = false
  },    
  [types.ORDER_SERVICES_CREATE_LOADING](state) {
    state.order.loading = true
    state.order.data = null
    state.order.error = false
  },
  [types.ORDER_SERVICES_CREATE_ERROR](state, error) {
    state.order.loading = false
    state.order.data = null
    state.order.error = error
  },
  [types.ORDER_SERVICES_CREATE_COMPLETE](state, payload) {
    state.order.loading = false
    state.order.data = payload
    state.order.error = false
  },  
  [types.GET_ORDERS_LOADING](state) {
    state.orders.loading = true
    state.orders.data = null
    state.orders.error = false
  },
  [types.GET_ORDERS_ERROR](state, error) {
    state.orders.loading = false
    state.orders.data = null
    state.orders.error = error
  },
  [types.GET_ORDERS_COMPLETE](state, payload) {
    state.orders.loading = false
    if(state.orders.data === null || payload.length !== state.orders.data.length) {
      /*state.orders.data = _.orderBy(_.map(payload, function(order) {
        return _.extend({}, order, { check: false });
      }), ['number'],['desc']);*/
      state.orders.data = _.map(payload, function(order) {
        return _.extend({}, order, { check: false });
      })
    }
    state.orders.error = false
  },
  [types.UPDATE_ORDERS](state, payload) {
    state.orders.loading = false
    debugger
    state.orders.data === payload
    state.orders.error = false
  },  
  [types.GET_ORDER_DETAIL_LOADING](state) {
    state.orderDetail.loading = true
    state.orderDetail.data = null
    state.orderDetail.error = false
  },
  [types.GET_ORDER_DETAIL_ERROR](state, error) {
    state.orderDetail.loading = false
    state.orderDetail.data = null
    state.orderDetail.error = error
  },
  [types.GET_ORDER_DETAIL_COMPLETE](state, payload) {
    state.orderDetail.loading = false
    state.orderDetail.data = payload
    state.orderDetail.error = false
  },  
  [types.CHANGE_STATUS_ORDER_LOADING](state) {
    state.orderDetail.loading = true
    state.orderDetail.data = null
    state.orderDetail.error = false
  },
  [types.CHANGE_STATUS_ORDER_ERROR](state, error) {
    state.orderDetail.loading = false
    state.orderDetail.data = null
    state.orderDetail.error = error
  },
  [types.CHANGE_STATUS_ORDER_COMPLETE](state, payload) {
    state.orderDetail.loading = false
    //state.orderDetail.data = payload
    state.orderDetail.error = false
  },   
}



//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/order/mutations.js
// module id = null
// module chunks = 